/**
 * Lazy-load videos: prevents below-fold <video> elements from loading
 * until they're near the viewport. Videos in the first visible section
 * are left alone so the hero loads immediately.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  function initLazyVideos() {
    var videos = document.querySelectorAll('video[autoplay]');
    if (!videos.length) return;

    // Skip the first video (likely hero / above-fold)
    var belowFold = Array.prototype.slice.call(videos, 1);
    if (!belowFold.length) return;

    belowFold.forEach(function (video) {
      video.removeAttribute('autoplay');
      video.setAttribute('preload', 'none');
      video.pause();
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var v = entry.target;
            v.setAttribute('preload', 'metadata');
            v.setAttribute('autoplay', '');
            v.play().catch(function () {});
            observer.unobserve(v);
          }
        });
      },
      { rootMargin: '200px' }
    );

    belowFold.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyVideos);
  } else {
    initLazyVideos();
  }
})();
